export default "__VITE_ASSET__16f20a62__"